import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      idModalFieldLibrary: 'modalFieldLibrary',
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      isNewFieldGroup: false,
      idProperties: 'configStackProperties',
      showFilterOptions: false,
      selectedField: null,
      selectedIndexField: null,
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', [
      'sourceModalFieldLibrary', 'showModalFieldLibrary',
    ]),
  },

  watch: {
    showModalFieldLibrary(val) {
      const data = this.sourceModalFieldLibrary;
      if (!val) {
        if (data) {
          const index = this.dataSetup.search_options_list.push(data) - 1;
          this.selectedField = this.dataSetup.search_options_list[index];
          this.selectedIndexField = index;
          this.isNewFieldGroup = true;
          this.setSourceModalFieldLibrary(null);

          setTimeout(() => {
            this.togglePropertiesField(true);
          }, 100);
        } else {
          this.setIsSearch(false);
        }
      }
    },
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setIsSearch', 'setIsShowModalFieldFromGroup',
      'setShowModalFieldLibrary', 'setSourceModalFieldLibrary',
      'setTypeViewSearch',
    ]),

    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
      });
    },

    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },

    addFilterFunction() {
      this.dataSetup.filter_function.push({
        key: null,
        value: null,
      });
    },

    deleteFilterFunction(index) {
      this.dataSetup.filter_function.splice(index, 1);
    },

    closeFilterOptions(id) {
      this.dataSetup.filterOperator = id;
      this.showFilterOptions = false;
    },

    // Open modal field library (search options list)
    openModalFieldLibrary(view) {
      if (!this.selectedField) {
        this.setIsSearch(true);
        this.setIsShowModalFieldFromGroup(true);
        this.setShowModalFieldLibrary(true);
        if (view === 'export') this.setTypeViewSearch(view);

        setTimeout(() => {
          const element = document.getElementById(this.idModalFieldLibrary);
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    closeModalFieldLibrary() {
      const element = document.getElementById(this.idModalFieldLibrary);
      if (element) element.classList.remove('show');

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
        this.setTypeViewSearch(null);
      }, 300);
    },

    // Edit field on search options list
    editField(index) {
      if (this.showModalFieldLibrary) this.closeModalFieldLibrary();
      this.selectedField = this.dataSetup.search_options_list[index];
      this.selectedIndexField = index;
      this.setIsSearch(true);
      this.togglePropertiesField(true);
    },

    // Delete field search option
    deleteField(index) {
      this.popupDeleteField(index);
    },

    popupDeleteField(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.search_options_list.splice(index || this.selectedIndexField, 1);
          this.togglePropertiesField(false);
        }
      });
    },

    // Submit data in stacked properties
    submitField(mode, params, isCancel) {
      const isHaveUiKey = params.field_ui_key;

      if (isHaveUiKey) {
        const sourceData = this.dataSetup.search_options_list;
        const findKeySame = sourceData.find(e => e.field_ui_key === params.field_ui_key);
        const param = {
          type: params.type,
          name: params.name,
          config: params.config,
          field_data_key: params.field_data_key,
        };

        if (mode === 'add') {
          if (!findKeySame) {
            this.isError = false;
            if (!isCancel) {
              this.dataSetup.search_options_list.push(param);
              this.togglePropertiesField(false);
            }
          } else {
            this.isError = true;
            this.toggleProblem('Variable cannot be the same!');
            setTimeout(() => {
              this.isError = false;
            }, 500);
          }
        } else {
          // eslint-disable-next-line
          if (this.selectedField.field_ui_key === params.field_ui_key) {
            this.isError = false;
            if (!isCancel) {
              this.dataSetup.search_options_list[this.selectedIndexField] = param;
              this.togglePropertiesField(false);
            }
          } else {
            // eslint-disable-next-line
            if (!findKeySame) {
              this.isError = false;
              if (!isCancel) {
                this.dataSetup.search_options_list[this.selectedIndexField] = param;
                this.togglePropertiesField(false);
              }
            } else {
              this.isError = true;
              this.toggleProblem('Variable cannot be the same!');
              setTimeout(() => {
                this.isError = false;
              }, 500);
            }
          }
        }
      } else if (!isHaveUiKey) {
        if (params.field_data_key) {
          const param = {
            type: params.type,
            name: params.name,
            config: params.config,
            field_data_key: params.field_data_key,
          };

          if (mode === 'add') {
            if (!isCancel) {
              this.dataSetup.search_options_list.push(param);
              this.togglePropertiesField(false);
            }
          } else if (mode === 'edit') {
            if (!isCancel) {
              this.dataSetup.search_options_list[this.selectedIndexField] = param;
              this.togglePropertiesField(false);
            }
          }
        } else {
          this.dataSetup.search_options_list.splice(this.selectedIndexField, 1);
        }
      }

      this.setIsSearch(false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixConfiguration.js